import { Inject, Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AdminMe } from './admin-me';
import { filter } from 'rxjs/operators';
import { WINDOW } from '@core/tools/window';
import { parseToken } from '@core/tools/parse-token';
import { AdminMeSerializer } from './adminMe.serializer';
import { ADMIN_CONFIG, AdminToken } from '../administrator/administrator';

@Injectable({providedIn: 'root'})
export class AdminMeStoreService {
  private _storage: Storage;
  private _adminMe: BehaviorSubject<AdminMe | null> = new BehaviorSubject<AdminMe | null>(null);
  public $adminMe: Observable<AdminMe> = this._adminMe.pipe(filter((admin) => !!admin));

  public hasAdmin = false;
  public adminMe: AdminMe;

  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(ADMIN_CONFIG) private config: AdminToken
  ) {
    this._storage = this.window.localStorage;
  }


  initAdmin(): AdminMe {
    const me = this.readAdminFromToken();
    this.setAdminMe(me);
    return me;
  }

  setAdminMe(user: AdminMe): void {
    this.adminMe = user;
    this._adminMe.next(this.adminMe);
    this.hasAdmin = !!user;
  }

  getAdminMe(): AdminMe | null {
    return this.adminMe;
  }

  clearAdmin(): void {
    this._adminMe.next(null);
    this.hasAdmin = false;
  }

  readAdminFromToken(): AdminMe {
    const token: string = this._storage.getItem('AuthToken') as string;
    const serializer = new AdminMeSerializer(this.config);
    const me = serializer.fromJson(parseToken(token));

    return me;
  }
}
